import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { File } from 'app/models/file'
import { FilesService } from 'app/services/files.service'
import { AssetsFactory } from 'app/services/assets.factory.services'
import { AssetSortingType } from 'app/models/asset-sorting-type'
import { ColumnSortComponent } from 'app/shared/components/column-sort/column-sort.component'
import { Source } from 'app/models/source.enum'
import { GoogleTagManagerService } from '../../../services/google-tag-manager.service'

@Component({
  selector: 'app-files-dashboard',
  templateUrl: './files-dashboard.component.html',
  styleUrls: ['./files-dashboard.component.scss'],
  providers: [FilesService, AssetsFactory]
})
export class FilesDashboardComponent extends ColumnSortComponent implements OnInit {
  files: Array<File>
  sortingType: AssetSortingType
  lastEvaluatedKey: any
  firstSort: Boolean

  @Input() topicfiles: Array<File>
  @Input() showHeader: boolean
  @Output() onChangingSortType = new EventEmitter()

  constructor(
    private filesService: FilesService,
    private assetService: AssetsFactory,
    private gtmService: GoogleTagManagerService,
  ) {
    super(assetService)
    this.showHeader = true
    this.firstSort = true
  }

  ngOnInit() {
    this.assetType = Source.Image
    this.getAll()
  }

  ngOnDestroy() {
    this.onChangingSortType.unsubscribe()
  }

  changeSorting(sortingType): void {
    // should bubble up the event and request data from server
    this.sortingType = sortingType
    this.getAll()
    if (!this.firstSort) {
      this.gtmService.pushEvent(`Sort by - ${sortingType.name}`)
    }
    this.firstSort = false
  }

  getAll(lastEvaluatedKey?: string): void {
    this.filesService
      .getAll(lastEvaluatedKey, (this.sortingType) ? this.sortingType.id : undefined)
      .subscribe(data => {
        this.files = this.files && lastEvaluatedKey ?
          this.files.concat(data.Items) : data.Items
        this.lastEvaluatedKey = data.LastEvaluatedKey
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/files-dashboard/files-dashboard.component.ts